export default "__VITE_ASSET__CKwkuqi4__"